
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    data() {
      return {
        isAppCatering: false,
        appCateringRoutes: [ // routes to show the app catering footer on
          '/',
          // '/menu',
          // '/order',
          '/offers',
          '/account',
          '/account/settings',
          '/account/payments',
          '/account/order-history'
        ]
      }
    },
    computed: {
      ...mapState(['location','order','channel','globalClass']),
      mobile() {
        return this.$mq == 'sm' || this.$mq == 'md'
      },
      showMobileNav() {
        return (
          (this.$mq == 'sm' || this.$mq == 'md') &&
          (
            this.$route.name !== 'order-product' &&
            this.$route.name !== 'order-checkout' &&
            this.$route.name !== 'order-items' &&
            this.$route.name !== 'account-login'
          )
        )
      },
      count() {
        if (this.order && this.order.products.length) {
          let count = 0
          this.order.products.forEach(product => {
            count += product.quantity
          })
          return count
        } else {
          return false
        }
      },
      year() {
        return moment().year()
      }
    },
    methods: {
      setPickup() {
        if (this.order && this.order.handoff == 'dispatch') {
          this.$api.setHandoff('pickup')
        } else {
          this.$router.push('/locations?mode=pickup')
        }
      },
      setDelivery() {
        this.$router.push('/locations?mode=delivery')
      },
      initScript() {
        window.interdeal = {
          "sitekey": "f00bec87189628e2f1de194645600273",
          "Position": "left",
          "Menulang": "EN",
          "hideBtn": true,
          "domains": {
            "js": "https://cdn.equalweb.com/",
            "acc": "https://access.equalweb.com/"
          },
          "btnStyle": {
            "vPosition": [
              "80%",
              "80%"
            ],
            "scale": [
              "0.6",
              "0.6"
            ],
            "color": {
              "main": "#000000",
              "second": "#ffffff"
            },
            "icon": {
              "type": 12,
              "shape": "circle"
            }
          }
        };
        this.loadScript(document, document.head, document.body)
      },
      loadScript(doc, head, body) {
        var coreCall = doc.createElement('script')
        coreCall.src = interdeal.domains.js + 'core/4.6.3/accessibility.js'
        coreCall.defer = true
        coreCall.integrity = 'sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ=='
        coreCall.crossOrigin = 'anonymous'
        coreCall.setAttribute('data-cfasync', true)
        body ? body.appendChild(coreCall) : head.appendChild(coreCall)
      },
      equalWeb() {
        if (window?.interdeal?.a11y?.openMenu) {
          window?.interdeal?.a11y?.openMenu()
        }
      }
    },
    mounted() {
      if (process.client) {
        // Retrieve source cookie to determine if we're coming from app
        const cookies = document.cookie
          .split('; ')
          .reduce((acc, cookie) => {
            const [key, value] = cookie.split('=')
            acc[key] = value
            return acc
          }, {})
        if (cookies.source && cookies.source == 'app' && this.channel == 'catering') {
          this.isAppCatering = true
          this.$nextTick(() => {
            document.querySelector('footer').style.padding = '20px'
            document.querySelectorAll('footer div > div:not(.mobile-nav):not(.app-catering-footer):not(.handoff-toggle)')
              .forEach(div => {
                if (div.nodeType === Node.ELEMENT_NODE) {
                  div.style.display = 'none'
                }
              })
          })
        }
      }

      // Initialize EqualWeb accessibility script
      this.initScript()
    },
  }
